module.exports = __webpack_public_path__ + "assets/img/7f3c-lb.svg";